import { DisclaimerManagerV1, ReferenceDisclaimerKind } from '@volkswagen-onehub/disclaimer-manager';
import * as React from 'react';

export function useDisclaimer(
  disclaimer: string,
  kind: ReferenceDisclaimerKind,
  disclaimerManager: DisclaimerManagerV1,
): string | undefined {
  // get default scoped disclaimer manager. scope should be assigned to this feature app by integrator.
  const scopedDisclaimerManager = React.useMemo(
    () => disclaimerManager.getScopedDisclaimerManager(),
    [disclaimerManager],
  );
  // remove old disclaimer
  React.useEffect(() => {
    return () => {
      scopedDisclaimerManager.unregisterReferenceDisclaimer(kind, disclaimer);
    };
  }, [kind, disclaimer, scopedDisclaimerManager]);

  // registered new disclaimer once
  return React.useMemo(() => {
    return scopedDisclaimerManager.registerReferenceDisclaimer(kind, disclaimer);
  }, [scopedDisclaimerManager, disclaimer, kind]);
}
